// Libraries
import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const createSatisfactionSurvey = async (satisfactionSurvey) => {
  try {
    const { data } = await Axios({
      baseURL: envConfig.partner,
      url: '/partners/save-satisfaction-survey/',
      method: 'post',
      data: satisfactionSurvey
    })
    return data
  } catch (error) {
    return error.response.data
  }
}

export const getProfessionalRatings = async ({ professionalId, skip, limit }) => {
  try {
    const { data } = await Axios({
      baseURL: envConfig.partner,
      url: `/professionals/ratings/${professionalId}`,
      params: {
        skip,
        limit
      },
      method: 'get'
    })
    return data
  } catch (error) {
    return error.response.data
  }
}
